document.addEventListener("DOMContentLoaded", function() {
  const radios = document.querySelectorAll('input[name="age_filter"]');
  const items = document.querySelectorAll(".grid__item.test");
  const counters = document.querySelectorAll(".product-count, .product-count__text"); 
  const mobileSelect = document.getElementById("AgeFilter-mobile");

  function applyFilter(selectedFilter) {
    let visibleCount = 0;

    items.forEach(item => {
      const productAges = item.dataset.age || "";
      if (!selectedFilter || productAges.includes(selectedFilter)) {
        item.style.display = "block";
        visibleCount++;
      } else {
        item.style.display = "none";
      }
    });

    // update product counter
    const text = visibleCount + (visibleCount === 1 ? " product" : " products");

    counters.forEach(el => {
      el.textContent = text;
    });
  }

  // Initial run from URL
  const urlParams = new URLSearchParams(window.location.search);
  const initialFilter = urlParams.get("age_filter");
  if (initialFilter) {
    document.querySelector(`input[name="age_filter"][value="${initialFilter}"]`)?.setAttribute("checked", "checked");
    if (mobileSelect) mobileSelect.value = initialFilter;
  }
  applyFilter(initialFilter);

  // Listen for filter changes
  radios.forEach((radio) => {
    radio.addEventListener("change", function () {
      const selected = this.value;

      // Update URL
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("age_filter", selected);

      // Reload the page with updated filter
      window.location.href = newUrl.toString();
    });
  });

  // Mobile dropdown
  if (mobileSelect) {
    // Keep selected option when reloading
    if (initialFilter) {
      mobileSelect.value = initialFilter;
    }

    mobileSelect.addEventListener("change", function () {
      const selected = this.value;

      const newUrl = new URL(window.location.href);
      if (selected) {
        newUrl.searchParams.set("age_filter", selected);
      } else {
        newUrl.searchParams.delete("age_filter");
      }

      // Reload page
      window.location.href = newUrl.toString();
    });
  }
});
